// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"3422f553","359":"0af3bd3e","772":"2b7b758b"}[chunkId] + ".chunk.css";
};